import * as React from "react";
import MuiAvatar from "@mui/material/Avatar";
import MuiListItemAvatar from "@mui/material/ListItemAvatar";
import MenuItem from "@mui/material/MenuItem";
import ListItemText from "@mui/material/ListItemText";
import Select, {selectClasses} from "@mui/material/Select";
import {styled} from "@mui/material/styles";
import {DevicesRounded} from "@mui/icons-material";
import {Typography, Grid} from "@mui/material";
import {ListItem, ListItemButton} from "@mui/material";
import {useAuthRoutes} from "@/store/menu.c";
import {IconMap} from "@/widget/IconMap/IconMap";
import SvgIcon from "@mui/material/SvgIcon";
import {useRouter} from "@/helper/hooks";
import {get} from "lodash";
import {AuthRouteVO} from "@/service/menu.s";

const Avatar = styled(MuiAvatar)(({theme}) => ({
    width: 32,
    height: 32,
    backgroundColor: (theme.vars || theme).palette.background.paper,
    color: (theme.vars || theme).palette.text.secondary,
    border: `1px solid ${(theme.vars || theme).palette.divider}`,
}));

const ListItemAvatar = styled(MuiListItemAvatar)({
    minWidth: 0,
    marginRight: 0,
});

export default function SelectContent() {
    const router = useRouter()
    const authRoutes = useAuthRoutes();
    return (
        <Select
            value={""}
            displayEmpty
            fullWidth
            sx={{
                maxHeight: 56,
                // width: 215,
                "&.MuiList-root": {
                    p: "8px",
                },
                [`& .${selectClasses.select}`]: {
                    display: "flex",
                    alignItems: "center",
                    gap: "2px",
                    pl: 1
                },
            }}>
            <MenuItem value="" sx={{display: 'none'}}>
                <ListItemAvatar>
                    <Avatar sx={{"& .MuiAvatar-img": {objectFit: 'contain'}}} alt="科达办公" src={"https://oss.kedaip.cn/keda/assets/logos.png"}>
                        <DevicesRounded sx={{fontSize: "1rem"}}/>
                    </Avatar>
                </ListItemAvatar>
                <ListItemText
                    primary={
                        <Typography
                            variant="h6"
                            component={"h6"}
                            fontWeight={540}
                            letterSpacing={2}>
                            科达办公
                        </Typography>
                    }
                />
            </MenuItem>
            <MenuItem value="1" sx={{padding: 0, "&:hover": {backgroundColor: "#fff"}}}>
                <Grid container width={480} px={0.5} py={1.1} spacing={1.4}>
                    {authRoutes?.map((authRoute: AuthRouteVO, index: number) => {
                        const secondary = authRoute?.children?.map(item => item.menuName)
                        const firstPath = get(authRoute, 'children[0].path', '')
                        return <Grid key={index} size={6}>
                            <ListItem disablePadding={true}>
                                <ListItemButton onClick={() => {
                                    firstPath && router.push(firstPath)
                                }}>
                                    <ListItemAvatar sx={{borderRadius: '100%'}}>
                                        <Avatar sx={{backgroundColor: '#eff4fa'}}>
                                            <SvgIcon component={IconMap[authRoute.source]}>
                                            </SvgIcon>
                                        </Avatar>
                                    </ListItemAvatar>
                                    <ListItemText primary={authRoute.menuName}
                                                  secondary={<Typography variant={'subtitle2'} fontSize={10} color={'textSecondary'} whiteSpace={'nowrap'} textOverflow={'ellipsis'}
                                                                         overflow={'hidden'}>{secondary?.join(",")}</Typography>}/>
                                </ListItemButton>
                            </ListItem>
                        </Grid>
                    })}
                </Grid>
            </MenuItem>
        </Select>
    )
        ;
}
